<template>
  <div>
    <div
      v-click-outside="collapseDropdown"
      class="configuration-dropdown-menu"
    >
      <div
        class="configuration"
        aria-haspopup="true"
        @click="toggleDropdown"
      >
        CONFIGURATION
        <span :class="{'down-arrow': !isExpanded, 'up-arrow': isExpanded}" />
      </div>
      <div
        v-show="isExpanded"
        class="configuration-dropdown-menu-options-container"
      >
        <router-link
          to="/build-types"
          class="configuration-dropdown-menu-option first"
          @click="collapseDropdown"
        >
          Build Types
        </router-link>
        <router-link
          to="/calibers"
          class="configuration-dropdown-menu-option"
          @click="collapseDropdown"
        >
          Calibers
        </router-link>
        <router-link
          to="/inventory-types"
          class="configuration-dropdown-menu-option"
          @click="collapseDropdown"
        >
          Inventory Types
        </router-link>
        <router-link
          to="/manufacturers"
          class="configuration-dropdown-menu-option"
          @click="collapseDropdown"
        >
          Manufacturers
        </router-link>
        <router-link
          to="/services"
          class="configuration-dropdown-menu-option"
          @click="collapseDropdown"
        >
          Services
        </router-link>
        <router-link
          to="/suppliers"
          class="configuration-dropdown-menu-option"
          @click="collapseDropdown"
        >
          Suppliers
        </router-link>
        <router-link
          to="/users"
          class="configuration-dropdown-menu-option last"
          @click="collapseDropdown"
        >
          Users
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ConfigurationDropdownMenu',
  data() {
    return {
      isExpanded: false
    }
  },
  methods: {
    toggleDropdown(): void {
      this.isExpanded = !this.isExpanded
    },
    collapseDropdown(): void {
      this.isExpanded = false
    }
  }
})
</script>

<style scoped lang="scss">

.configuration-dropdown-menu {
  position: relative;

  > .configuration {
    cursor: pointer;
    font-weight: bold;
    color: $Color-font-colored-background;
    font-size: 16px;
    padding-right: 16px;
    line-height: 25px;
    
    > .up-arrow {
      @include up-arrow;
      position: absolute;
      right: 0;
      top: 16px;
    }

    > .down-arrow {
      @include down-arrow;
      position: absolute;
      right: 0;
      top: 10px;
    }
  }

  > .configuration-dropdown-menu-options-container {
    position: absolute;
    right: 0;
    min-width: 154px;
    background: $Color-white;
    border: 1px solid $Color-fill-black;
    @include element-shadow;
    
    > .configuration-dropdown-menu-option {
      display: block;
      text-align: right;
      color: $Color-font-high;
      font-size: 18px;
      text-decoration: none;
      padding: 8px 16px;
      cursor: pointer;

      &.first {
        padding-top: 16px;
      }

      &.last {
        padding-bottom: 16px;
      }

      &:hover {
        color: $Color-sac-orange;
      }
    }
  }
}

</style>
